import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
});

// Entidades soportadas por el backend: product (grupos), item, category, segment, promotion
export class TranslationsFetchAPI {

    //Function to get the entities that support translations
    static async getSupportedEntities(token) {
        const res = await server(`/translations/entities`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to get every translation (all languages) registered for a row
    static async getTranslations(entity, entityId, token) {
        const res = await server(`/translations/${entity}/${entityId}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to create or update the translation of a row for a given language
    static async upsertTranslation(entity, entityId, data, token) {
        const res = await server(`/translations/${entity}/${entityId}`, {
            method: "post",
            data: {
                language_code: data.language_code,
                name: data.name,
                description: data.description,
            },
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to delete the translation of a row for a given language
    static async deleteTranslation(entity, entityId, language_code, token) {
        const res = await server(`/translations/${entity}/${entityId}/${language_code}`, {
            method: "delete",
            headers: { 'x-access-token': token },
        });
        return res
    }

}
